// /* eslint-disable react-hooks/exhaustive-deps */
// import { Provider, useDispatch, useSelector } from "react-redux";
// import "./App.css";
// import { PageRoutes } from "./PageRouting";
// import store from "./store";
// import { getDataFromLocal, saveLoggedUser } from "./Redux/actions/AuthActions";
// import { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { db, onForegroundMessage } from "./config/firebase";
// import { collection, deleteDoc, doc, getDocs, onSnapshot, query, serverTimestamp, updateDoc, where } from "firebase/firestore";
// import IncomingCallModal from "./Pages/IncomingCallModal";
// import { convertUTCDate } from "./utils/convertionFunc";
// import AppointmentService from "./Services/AppointmentService";
// import { APP_ROUTES } from "./PageRouting/pageRoutes";
// import { setSelectedAppt } from "./Redux/actions/appointmentActions";

// function App() {
//   const dispatch = useDispatch();
//   const [incomingData, setIncomingData] = useState([]);
//   const navigate = useNavigate();
//   const { loggedUser } = useSelector((state) => state.auth);
//   const { selectedAppt } = useSelector((state) => state.appt);

//   useEffect(() => {
//     if (!loggedUser) {
//       const loggedUserObj = localStorage.getItem("patientData");
//       const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
//       dispatch(saveLoggedUser(loggedUser));
//     }
//   }, [loggedUser]);

//   useEffect(() => {
//     const patientId = loggedUser?.patientId;
//     if (!patientId) return;

//     const callsRef = collection(db, "calls");

//     const q = query(
//       callsRef,
//       where("incomingCall.receiverId", "==", patientId),
//       where("incomingCall.status", "==", 1)
//     );

//     const unsubscribe = onSnapshot(q, async (snapshot) => {
//       if (snapshot.empty) {
//         localStorage.removeItem("incoming");
//         localStorage.removeItem("incomingModal");
//         setIncomingData([]);
//         return;
//       }

//       const calls = snapshot.docs.map(doc => ({
//         id: doc.id,
//         ...doc.data()
//       }));

//       setIncomingData(calls);
//       localStorage.setItem("incoming", JSON.stringify(calls));
//       localStorage.setItem("incomingModal", "true");
//     });

//     return () => unsubscribe();
//   }, [loggedUser, selectedAppt]);

//   const handleAcceptCall = async (roomId) => {
//     if (!roomId) return;
//     const roomObj = incomingData?.find((item) => item.incomingCall.roomId === roomId)?.incomingCall;
//     localStorage.setItem("callRoomId", roomObj.roomId);

//     // Clear record from firebase
//     // await deleteFirebaseCallRecord(callerId);
//     await updateDoc(doc(db, "calls", roomId), {
//       "incomingCall.status": 2, // in call
//       "incomingCall.acceptedAt": serverTimestamp()
//     });


//     // Navigate to call
//     const currentDate = new Date();
//     const formattedDate = convertUTCDate(currentDate, "YYYY-MM-DD HH:mm:ss");
//     const payload = {
//       appointmentId: roomObj.roomId
//     }
//     const res = await AppointmentService.getPatientAppointment(payload);
//     const details = res.data[0];
//     dispatch(setSelectedAppt(details));
//     localStorage.setItem("selectedAppt", JSON.stringify(details));
//     if (details.serviceCode !== "APPT_VIDEO") {
//       return;
//     }

//     try {
//       let payload1 = {
//         patientName: details?.patientName,
//         personType: "Patient",
//         appointmentId: details.appointmentId,
//         modifiedBy: details.userId,
//         modifiedDate: formattedDate,
//         patientId: details.patientId,
//         queueStatus: "Y",
//         userId: details.userId,
//         joiningDateTime: formattedDate,
//       };
//       await AppointmentService.callQueueUpdate(payload1);
//       // Clear popup
//       const updatedState = incomingData?.filter(item => item.incomingCall.roomId !== roomId) || [];
//       if (updatedState?.length === 0) {
//         localStorage.removeItem("incoming");
//         localStorage.removeItem("incomingModal");
//       }
//       else {
//         localStorage.setItem("incoming", JSON.stringify(updatedState));
//       }
//       setIncomingData((prevState) => prevState?.filter(item => item.incomingCall.roomId !== roomId));
//       navigate(APP_ROUTES.VIDEOCALL, {
//         state: { selectedAppDetails: details },
//       });
//     } catch (error) {
//       console.error("Error updating appointment or queue:", error);
//     }
//   };

//   const handleRejectCall = async (roomId) => {
//     if (!roomId) return;
//     // await deleteFirebaseCallRecord(callerId);
//     await updateDoc(doc(db, "calls", roomId), {
//       "incomingCall.status": -1,
//       "incomingCall.endedAt": serverTimestamp()
//     });

//     const updatedState = incomingData?.filter(item => item.incomingCall.roomId !== roomId) || [];
//     if (updatedState?.length === 0) {
//       localStorage.removeItem("incoming");
//       localStorage.removeItem("incomingModal");
//     }
//     else {
//       localStorage.setItem("incoming", JSON.stringify(updatedState));
//     }

//   };

//   const deleteFirebaseCallRecord = async (callerId) => {
//     if (!callerId) return;

//     try {
//       await deleteDoc(doc(db, "calls", callerId));
//       setIncomingData(prev =>
//         prev.filter(item => item.incomingCall.callerId !== callerId)
//       );
//     }
//     catch (e) {
//       console.log(e);
//     }
//   }

//   useEffect(() => {
//     dispatch(getDataFromLocal());
//   }, [dispatch]);

//   return (
//     <>
//       <PageRoutes />
//       <IncomingCallModal
//         data={incomingData}
//         onAccept={handleAcceptCall}
//         onReject={handleRejectCall}
//       />
//     </>
//   );
// }

// export default App;

// ─────────────────────────────────────────────────────────────────────────────
// PATIENT APP — App.js
// ─────────────────────────────────────────────────────────────────────────────
/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import "./App.css";
import { PageRoutes } from "./PageRouting";
import { getDataFromLocal, saveLoggedUser } from "./Redux/actions/AuthActions";
import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { db, CALL_STATUS } from "./config/firebase";
import {
  collection,
  doc,
  onSnapshot,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import IncomingCallModal from "./Pages/IncomingCallModal";
import { convertUTCDate } from "./utils/convertionFunc";
import AppointmentService from "./Services/AppointmentService";
import { APP_ROUTES } from "./PageRouting/pageRoutes";
import { setSelectedAppt } from "./Redux/actions/appointmentActions";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [incomingData, setIncomingData] = useState([]);
  const { loggedUser } = useSelector((state) => state.auth);
  const { selectedAppt } = useSelector((state) => state.appt);

  // ─── Rehydrate logged user ─────────────────────────────────────────────────
  useEffect(() => {
    dispatch(getDataFromLocal());
  }, [dispatch]);

  useEffect(() => {
    if (!loggedUser) {
      const raw = localStorage.getItem("patientData");
      const parsed = raw ? JSON.parse(raw) : null;
      dispatch(saveLoggedUser(parsed));
    }
  }, [loggedUser]);

  // ─── Listen for incoming call notifications (patient is the RECEIVER) ───────
  // FIX: removed `selectedAppt` from deps to prevent unnecessary re-subscription.
  // The IncomingCallModal filter handles suppressing notifications when the
  // patient is already inside that appointment's video room.
  useEffect(() => {
    console.log(' loggedUser ',loggedUser)
    const patientId = loggedUser?.patientId;
    if (!patientId) return;

    const q = query(
      collection(db, "calls"),
      where("incomingCall.receiverId", "==", patientId),
      where("incomingCall.status", "==", CALL_STATUS.RINGING)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (snapshot.empty) {
        setIncomingData([]);
        return;
      }
      const calls = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      console.log('calls ',calls);
      setIncomingData(calls);
    });

    return () => unsubscribe();
  }, [loggedUser?.patientId]); // ← only re-subscribe when patient changes

  // ─── Accept call (via the call notification popup) ───────────────────────
  const handleAcceptCall = useCallback(
    async (roomId) => {
      if (!roomId) return;

      const roomObj = incomingData?.find(
        (item) => item.incomingCall.roomId === roomId
      )?.incomingCall;
      if (!roomObj) return;

      localStorage.setItem("callRoomId", roomObj.roomId);

      // Mark as in-call so the caller's side knows the patient joined
      await updateDoc(doc(db, "calls", roomId), {
        "incomingCall.status": CALL_STATUS.IN_CALL,
        "incomingCall.acceptedAt": serverTimestamp(),
      });

      try {
        const res = await AppointmentService.getPatientAppointment({
          appointmentId: roomObj.roomId,
        });
        const details = res.data[0];

        if (details.serviceCode !== "APPT_VIDEO") return;

        dispatch(setSelectedAppt(details));
        localStorage.setItem("selectedAppt", JSON.stringify(details));

        const formattedDate = convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss"
        );

        await AppointmentService.callQueueUpdate({
          patientName: details?.patientName,
          personType: "Patient",
          appointmentId: details.appointmentId,
          modifiedBy: details.userId,
          modifiedDate: formattedDate,
          patientId: details.patientId,
          queueStatus: "Y",
          userId: details.userId,
          joiningDateTime: formattedDate,
        });

        // Dismiss immediately for instant UI feedback
        setIncomingData((prev) =>
          prev.filter((item) => item.incomingCall.roomId !== roomId)
        );

        navigate(APP_ROUTES.VIDEOCALL, {
          state: { selectedAppDetails: details },
        });
      } catch (error) {
        console.error("handleAcceptCall error:", error);
      }
    },
    [incomingData, dispatch, navigate]
  );

  // ─── Reject call ──────────────────────────────────────────────────────────
  // FIX: clears local state immediately (optimistic); does NOT delete the
  // Firestore document — that is the caller's responsibility.
  // Setting status to REJECTED stops the query from matching, so the
  // listener will also clear state via snapshot.
  const handleRejectCall = useCallback(async (roomId) => {
    if (!roomId) return;

    // Optimistic local dismissal so modal disappears instantly
    setIncomingData((prev) =>
      prev.filter((item) => item.incomingCall.roomId !== roomId)
    );

    try {
      await updateDoc(doc(db, "calls", roomId), {
        "incomingCall.status": CALL_STATUS.REJECTED,
        "incomingCall.endedAt": serverTimestamp(),
      });
    } catch (err) {
      console.error("handleRejectCall error:", err);
    }
  }, []);

  return (
    <>
      <PageRoutes />
      {/*
        IncomingCallModal filters out notifications for the room the patient
        is already in (selectedAppt.appointmentId), so even if a stale doc
        exists in Firestore, it won't show while the patient is in that room.
      */}
      <IncomingCallModal
        data={incomingData}
        onAccept={handleAcceptCall}
        onReject={handleRejectCall}
      />
    </>
  );
}

export default App;